import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import useAppsTesting from "../hooks/AppsTestingHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";

const StudentTestScores = ({ schoolId, linkColor }) => {
  const { data, loading, error } = useAppsTesting(schoolId);
  const theme = useTheme();

  if (loading) {
    return <div>Loading...</div>;
  }

  const report_3_link = data.length > 0 ? data[0].report_3_link : "#";
  const subject = "Student Test Scores Entry";

  return (
    <Card>
      <CardHeader
        title="Student Test Scores Entry"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {report_3_link && (
          <>
            <Link
              to={report_3_link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: linkColor }}
            >
              View Report
            </Link>
            <SchoolNotificationButton subject={subject} schoolId={schoolId} />
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default StudentTestScores;
